exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".options-container[data-v-7c6177af] {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  align-items: start;\n}\n", ""]);

